import * as React from 'react';
import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import api from "../../utils/api";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";

import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 20px)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  '& div :focus-visible':{outline:0} ,
  '& .slick-prev' : {
    left:0,
    zIndex:99
  },
  '& .slick-next' : {
    right:10,
    zIndex:99
  },
  '& .slick-prev:before, .slick-next:before' : {
    fontSize:30,
    color:'#999'
  },

};

const MainNews = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [imageList, setImageList] = React.useState([]);
  const [contentList, setContentList] = React.useState([{ title: '', thumbNail: '', images: [], hashTags: [] }]);

  useEffect(() => {
    let params = { page: 0 };
    api.post(`content/readAllCardNews`, params).then(res1 => {
      for (let i = 0; i < Math.floor(res1.data.count / 10); i++) {
        params.page = i;
        api.post(`content/readAllCardNews`, params).then(res => {
          setContentList((prev) => prev.concat(res.data.cardNewsList).sort(() => Math.random() - 0.5));
        }).catch(function (error) {
          console.log(error)
        });
      }
    }).catch(function (error) {
      console.log(error)
    });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleOpen = (images: any) => {
    setImageList(images);
    setOpen(true);
  }
  const handleClose = () => setOpen(false);


  return (
    <React.Fragment>

      <Box sx={{ width: '100%', mt: 3 }}>
        <Stack direction={'row'} alignItems={'center'}>
          <Typography sx={{ fontWeight: 700, color: '#777', fontSize: 20 }}>건강 뉴스</Typography>
          <Typography sx={{ml:'auto', fontSize:14,}}  onClick={() => navigate('../News/HealthNews')}>전체보기 <ChevronRightIcon fontSize='small' sx={{verticalAlign:'sub', color:'#555'}} /></Typography>
        </Stack>

        <Box sx={{ whiteSpace: 'nowrap'}}>
          <ImageList sx={{ overflowX: 'scroll', overflowY: 'hidden', display: 'block' , pb:1 }}>
            {contentList && contentList.slice(0, 5).map((item, index) => (
              <ImageListItem key={index} sx={{
                width: 200, height: 100, display: 'inline-flex', mr: '20px',
                '& .MuiImageListItem-img': { height: 100, borderRadius: 4 }
              }} onClick={() => handleOpen(item.images)}>
                <img
                  src={'https://file.dualhealth.kr/healthContent/cardNews/' + item.thumbNail}
                  alt={item.title}
                />
                <Typography
                  sx={{
                    textAlign: 'center',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    mt: 1, mb: 1,
                    fontSize: 14,
                    fontWeight: 700
                  }}>
                  {item.title}
                </Typography>
                <Stack direction={'row'} spacing={1} overflow={'scroll'}>
                  {item && item.hashTags.map((tag, index) => (

                    <Chip size="small" label={tag} />

                  ))}
                </Stack>
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
        <Typography sx={{ textAlign: 'right', fontSize: 11, color: '#aaa' }}>출처 : 듀얼헬스케어,<a href="https://blog.naver.com/dualhealth_official" title="Dualheathcare" target='_blank' style={{ color: '#aaa', textDecoration: 'none' }}> https://blog.naver.com/dualhealth_official</a></Typography>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Slider {...settings}>
            {imageList && imageList.map((item, index) => (
              <Box key={index}  sx={{'&:focus-visible':{outline:0} }}>
                <Img alt="" src={'https://file.dualhealth.kr/healthContent/cardNews/' + item}  sx={{'&:focus-visible':{outline:0} }} />
              </Box>
            ))}
          </Slider>
        </Box>
      </Modal>

    </React.Fragment>
  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 5,
  boxSizing: 'border-box',
  pb: 10
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default MainNews;

